// extracted by mini-css-extract-plugin
export default {"header_wrapper":"Header_header_wrapper__vmotu","logo":"Header_logo__Qfhys"};